import { inputs } from "../../../inputs/inputConfigs";

export default ({ isTaxExempt, disabledTax }) => {
  return {
    groups: [
      {
        items: [
          {
            input: inputs.hasProjectAccounting,
            grid: { xs: 4, noPaddingLeft: true },
          },
          { input: inputs.projectIsPositivePay, grid: { xs: 4 } },
          { input: inputs.isTaxExempt, grid: { xs: 4 } },
          {
            input: { ...inputs.bankAccount, defaultVisible: !isTaxExempt },
            grid: { md: 3, sm: 6, xs: 12 },
          },
          {
            input: {
              ...inputs.saleTaxPercent,
              disabled: disabledTax,
            },
            grid: { md: 3, sm: 6, xs: 12 },
          },
          {
            input: {
              ...inputs.useTaxPercent,
              disabled: disabledTax,
            },
            grid: { md: 3, sm: 6, xs: 12 },
          },
          {
            input: {
              ...inputs.salesTaxTolerancePercent,
              disabled: disabledTax,
            },
            grid: { md: 3, sm: 6, xs: 12 },
          },
          {
            input: inputs.isFreightTaxable,
            grid: { xs: 12, noPaddingLeft: true },
          },
          {
            input: inputs.isInstallTaxable,
            grid: { xs: 12, noPaddingLeft: true },
          },
          { input: inputs.accountingDueWeekday, grid: { xs: 4 } },
        ],
      },
    ],
  };
};
